import {  useContext, useState } from "react";
import {
  Home,
  User,
  CreditCard,
  Menu,
  X,
  LogOut,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Context } from "../context/Context";

const Account = () => {
  const [active, setActive] = useState("Home");
  const [open, setOpen] = useState(false);
 
  const navigate = useNavigate();
   
  const {setAuth,myPayments} = useContext(Context);
  const user = JSON.parse(localStorage.getItem("user"));
  // Logout
  const handleLogout = () => {
    if (!window.confirm("Log out of your account?")) return;

    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setAuth(null);
    sessionStorage.clear();
    navigate("/");
  };

  const menu = [
    { name: "Home", icon: Home },
    // { name: "Personal Info", icon: User },
    // { name: "Security", icon: Shield },
    // { name: "Password", icon: KeyRound },
    { name: "Payments", icon: CreditCard },
    { name: "Log out", icon: LogOut, function: handleLogout },
  ];

  // ---------------- CONTENT ----------------

  const renderContent = () => {
    switch (active) {
      case "Home":
        return (
          <div className="grid md:grid-cols-3 gap-6">
            <Card title="Profile Completion" value="80%" />
            <Card title="Devices" value="1 Active" />
            <Card title="Security Score" value="Strong" />
          </div>
        );

      case "Personal Info":
        return (
          <div className="space-y-4 max-w-xl">
            <h3 className="text-xl font-semibold">Edit Personal Info</h3>

            <Input label="Full Name" defaultValue={user.name} />
            <Input label="Email" defaultValue={user.email} />
            {/* <Input label="Phone" defaultValue={user.phone} /> */}

            <button className="btn-primary">Save Changes</button>
          </div>
        );

      case "Security":
        return (
          <div className="space-y-6 max-w-xl">
            <h3 className="text-xl font-semibold">Security Settings</h3>

            <SecurityItem
              title="Two-Step Verification"
              desc="Protect your account with OTP verification"
              status="Off"
            />

            <SecurityItem
              title="Recent Activity"
              desc="No suspicious activity detected"
              status="Safe"
            />
          </div>
        );

      case "Password":
        return (
          <div className="space-y-4 max-w-md">
            <h3 className="text-xl font-semibold">Change Password</h3>

            <input type="password" placeholder="Current password" className="input" />
            <input type="password" placeholder="New password" className="input" />
            <input type="password" placeholder="Confirm password" className="input" />

            <button className="btn-primary">Update Password</button>
          </div>
        );

      case "Payments":
        return (
              <div className="space-y-6">
      <h3 className="text-2xl font-semibold">Payment History</h3>

      {myPayments.length === 0 ? (
        <div className="p-4 rounded-lg border dark:border-white/10 text-gray-500">
          No payments found.
        </div>
      ) : (
        <div className="space-y-4">
          {myPayments.map((p) => (
            <div
              key={p._id}
              className="p-5 rounded-xl border dark:border-white/10 bg-white dark:bg-[#111] shadow-sm flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
            >
              {/* LEFT SIDE */}
              <div className="space-y-1">
                <p className="font-semibold text-lg">
                  €{p.amount}
                </p>

                <p className="text-sm text-gray-500">
                  {p.TimeandDate}
                </p>

                <p className="text-xs text-gray-400">
                  Order ID: {p.orderId}
                </p>

                <p className="text-xs text-gray-400">
                  Payment ID: {p.paymentId}
                </p>
              </div>

              {/* RIGHT SIDE */}
              <div className="flex flex-col items-end gap-2">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    p.status === "success"
                      ? "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400"
                      : "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400"
                  }`}
                >
                  {p.status.toUpperCase()}
                </span>

                <p className="text-xs text-gray-400">
                  {new Date(p.orderDate).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex bg-gray-50 dark:bg-black text-black dark:text-white">

      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed md:static w-64 h-full bg-white dark:bg-black border-r dark:border-white/10 p-6 z-50 transform transition
        ${open ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
      >
        <div className="flex justify-between mb-6 md:hidden">
          <h2 className="font-semibold">Account</h2>
          <button onClick={() => setOpen(false)}>
            <X />
          </button>
        </div>

        <h2 className="text-xl font-semibold mb-6 hidden md:block">
          Dashboard
        </h2>

        <div className="space-y-2">
          {menu.map((item) => {
            const Icon = item.icon;

            return (
              <button
                key={item.name}
                onClick={() => {
                  setActive(item.name);
                  setOpen(false);
                  if (item.function) item.function();
                }}
                className={`sidebar-btn ${
                  active === item.name && "sidebar-active"
                }`}
              >
                <Icon size={18} />
                {item.name}
              </button>
            );
          })}
        </div>
      </aside>

      {/* MAIN */}
      <main className="flex-1 p-6">

        {/* Top Bar */}
        <div className="flex justify-between items-center mb-14">

          <button className="md:hidden" onClick={() => setOpen(true)}>
            <Menu size={26} />
          </button>

          {/* <h2 className="text-lg font-semibold">{active}</h2> */}

          {/* <button
            onClick={() => navigate("/")}
            className="border px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-white/10"
          >
            ← Landing Page
          </button> */}
        </div>

        {/* Profile Header */}
        <div className="flex items-center gap-4 mb-8">
          <User size={48} className="text-gray-500" />

          <div>
            <h1 className="font-semibold text-lg">{user.name}</h1>
            <p className="text-gray-500 text-sm">
              {user.email}
            </p>
          </div>
        </div>

        {/* Dynamic Content */}
        {renderContent()}
      </main>
    </div>
  );
};

export default Account;

//////////////////////////////////////////////////////////
// SMALL COMPONENTS
//////////////////////////////////////////////////////////

const Card = ({ title, value }) => (
  <div className="p-5 rounded-xl bg-white dark:bg-[#111] shadow border dark:border-white/10">
    <p className="text-sm text-gray-500">{title}</p>
    <h3 className="text-2xl font-semibold mt-2">{value}</h3>
  </div>
);

const Input = ({ label, defaultValue }) => (
  <div>
    <p className="text-sm mb-1">{label}</p>
    <input defaultValue={defaultValue} className="input" />
  </div>
);

const SecurityItem = ({ title, desc, status }) => (
  <div className="p-4 rounded-lg border dark:border-white/10">
    <div className="flex justify-between">
      <div>
        <h4 className="font-medium">{title}</h4>
        <p className="text-sm text-gray-500">{desc}</p>
      </div>
      <span className="text-sm font-semibold">{status}</span>
    </div>
  </div>
);
